import type { ReactNode } from 'react'
import { Button } from '~/components/ui/button'

// 제네릭 슬라이드오버 상세 셸 — 오버레이·헤더(제목·닫기)·스크롤 본문·로딩/오류만 공용화한다.
// 패널 고유 내용은 children(data)로 주입하고, 헤더 우측의 추가 액션(상세보기 등)은 headerActions로 받는다.

export interface SidePanelDetailProps<T> {
    title: ReactNode
    data: T | null
    loading: boolean
    error?: string | null
    onClose: () => void
    /** 헤더 우측, 닫기 버튼 앞에 놓이는 추가 액션(상세보기 네비 등). */
    headerActions?: ReactNode
    loadingText?: ReactNode
    children: (data: T) => ReactNode
}

export function SidePanelDetail<T>({
    title,
    data,
    loading,
    error,
    onClose,
    headerActions,
    loadingText = '불러오는 중…',
    children,
}: SidePanelDetailProps<T>) {
    return (
        <div className='fixed inset-0 z-50 flex justify-end'>
            <button
                type='button'
                aria-label='닫기'
                className='bg-background/60 absolute inset-0'
                onClick={onClose}
            />
            <div className='border-border bg-card relative flex h-full w-full max-w-2xl flex-col border-l shadow-lg'>
                <div className='border-border flex items-center justify-between border-b p-4'>
                    <h2 className='krds-title text-foreground'>{title}</h2>
                    <div className='flex items-center gap-2'>
                        {headerActions}
                        <Button variant='ghost' size='sm' onClick={onClose}>
                            닫기
                        </Button>
                    </div>
                </div>

                <div className='flex-1 space-y-6 overflow-y-auto p-4'>
                    {loading ? (
                        <p className='text-muted-foreground text-sm'>
                            {loadingText}
                        </p>
                    ) : error ? (
                        <p className='text-destructive text-sm'>{error}</p>
                    ) : data ? (
                        children(data)
                    ) : null}
                </div>
            </div>
        </div>
    )
}
